import React, { FC } from 'react';
import styles from './info-box.module.sass';

export const InfoBoxBody : FC<React.DetailedHTMLProps<React.HTMLAttributes<HTMLSpanElement>, HTMLSpanElement>> = ({className, ...props}) => {
  return <span {...props} className={`${styles.body} ${className ?? ""}`}>{props.children}</span>
}

export default InfoBoxBody;
